import { z } from 'zod';
export const ClaimInviteRequestSchema = z.object({
    inviteCode: z.string().min(8).max(128),
});
export const MeResponseSchema = z.object({
    data: z.object({
        userId: z.string(),
        email: z.string().email(),
        isPlatformAdmin: z.boolean(),
        // `name` is optional so a response from a backend predating the org
        // switcher still parses.
        orgs: z.array(z.object({ orgId: z.string().uuid(), role: z.string(), name: z.string().optional() })),
        // Ordered: events[0] is what the mobile app opens on.
        preferredEventId: z.string().uuid().nullable().optional(),
        moderates: z.array(z.string().uuid()),
        events: z.array(z.string().uuid()),
    }),
});
export const ClaimInviteResponseSchema = z.object({
    data: z.object({
        attendeeId: z.string().uuid(),
        eventId: z.string().uuid(),
        userId: z.string().uuid(),
    }),
});
//# sourceMappingURL=auth.js.map